<template>
  <page-header :title="pageTitle" />

  <template v-if="termsRequests !== null">
    <template v-if="termsRequests.length > 0">
      <q-card class="t-table terms-requests">
        <div class="t-row t-header">
          <div class="t-field t-field-name">Понятие</div>
          <div class="t-field">Автор</div>
          <div class="t-field">Добавленное слово</div>
          <div class="t-field t-field-actions"></div>
        </div>
        <div v-for="termRequest in termsRequests" :key="termRequest.id" class="t-row">
          <div class="t-field t-field-name">
            {{ termRequest.name }}
          </div>
          <div class="t-field">
            <div class="t-label">Автор</div>
            <router-link :to="{ name: 'users_view', params: {id: termRequest.author.id }}">{{ termRequest.author.name }}</router-link>
          </div>
          <div class="t-field">
            <template v-if="termRequest.term !== null">
              <div class="t-label">Добавленное слово</div>
              <router-link :to="{ name: 'terms_view', params: {id: termRequest.term.id }}">{{ termRequest.term.name }}</router-link>
            </template>
          </div>
          <div class="t-field t-field-actions">
            <term-request-context-menu :term-request="termRequest" :hook="reload" />
          </div>
        </div>
      </q-card>

      <pagination :page="filter.page" :pages="pages" />
    </template>
    <q-card v-else class="q-pa-lg">
      Нет предложенных слов.
    </q-card>
  </template>
</template>

<script>
import loading from '../../loading.js'
import { api as requestsApi } from '../../api/termsRequests.js'
import PageHeader from '../../blocks/PageHeader.vue'
import TermRequestContextMenu from '../../blocks/termsRequests/TermRequestContextMenu.vue'
import Pagination from '../../blocks/Pagination.vue'

const createFilter = function(query) {
  const filter = {
    page: 1,
  }

  if (query['page']) {
    filter.page = parseInt(query['page'])
  }

  return filter
}

async function preparePage(callback, to) {
  loading.start()
  const filter = createFilter(to.query)
  const termsRequests = await requestsApi.findBy(filter)
  const setInitData = vm => {
    vm.termsRequests = termsRequests
    vm.pages = termsRequests.meta.pages
    vm.total = termsRequests.meta.total
    vm.setFilter(filter)
  }
  callback(setInitData)
  loading.stop()
  loading.updateTitle(to.meta.title || '')
}

export default {
  components: {
    PageHeader,
    TermRequestContextMenu,
    Pagination,
  },
  async beforeRouteEnter(to, from, next) {
    await preparePage(setInitData => {
      next(setInitData)
    }, to)
  },
  async beforeRouteUpdate(to, from, next) {
    await preparePage(setInitData => {
      setInitData(this)
      next()
    }, to)
  },
  data() {
    return {
      termsRequests: null,
      total: null,
      filter: {
        page: 1,
      },
      pages: 0,
    }
  },
  methods: {
    async reload() {
      const termsRequests = await requestsApi.findBy(this.filter)
      this.termsRequests = termsRequests
      this.pages = termsRequests.meta.pages
      this.total = termsRequests.meta.total
    },
    setFilter(filter) {
      this.filter = filter
    },
  },
  computed: {
    pageTitle() {
      let pageTitle = 'Предложенные слова'
      if (this.total > 0) {
        pageTitle += ` (всего: ${this.total})`
      }
      return pageTitle
    }
  }
}
</script>
